import { render } from "./bannerComponent.vue?vue&type=template&id=3b69f8a7&scoped=true"
import script from "./bannerComponent.vue?vue&type=script&lang=js"
export * from "./bannerComponent.vue?vue&type=script&lang=js"

import "./bannerComponent.vue?vue&type=style&index=0&id=3b69f8a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b69f8a7"]])

export default __exports__